import { ChipEnums } from "../chip";
import { AlignSelf, Variant } from "../enum-types";

interface ActionListGroupItemProps {
    itemTitle?: string;
    actionButton?: ActionListGroupItemButtonProps;
    icon?: ActionListGroupItemIconProps;
    status?: ActionStatusProps;
    categories?: string[];
    truncateText?: boolean;
    isClickable?: boolean;
    actionTextClass?: string;
    variant?: Variant;
}

interface ActionListGroupItemButtonProps {
    text: string;
    iconName: string;
    buttonClassName: string;
}

interface ActionListGroupItemIconProps {
    iconName?: string;
    imageSrc?: string;
    align?: AlignSelf;
    altText?: string;
    className?: string;
    containerClassName?: string;
    bordered: boolean;
}

interface ActionStatusProps {
    dueDate?: string;
    variant?: ChipEnums.StatusVariant;
    label?: string;
    icon?: string;
}

interface AtlContactListGroupProps {
    columns?: number;
}

interface AtlContactListGroupItemProps {
    contactRole?: string;
    contactName?: string;
    pictureSrc?: string;
    email?: string;
    phone?: string;
}

export const ListGroupItemButtonClickEvent = 'atlantis-action-list-group-item-button-click';

export enum AtlListGroupTagNames {
    ActionListGroup = 'atlantis-action-list-group',
    ActionListGroupItem = 'atlantis-action-list-group-item',
    ContactListGroup = 'atlantis-contact-list-group',
    ContactListGroupItem = 'atlantis-contact-list-group-item'
}

export type {
    ActionListGroupItemProps,
    ActionListGroupItemButtonProps,
    ActionListGroupItemIconProps,
    ActionStatusProps,
    AtlContactListGroupProps,
    AtlContactListGroupItemProps,
};